import { useEditor } from '@modules/editor';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Iconify from 'src/components/iconify';
import { ChatMessageItem } from 'src/sections/@dashboard/chat/ChatConversation/ChatMessageList/ChatMessageItem';
import { useChatSearchQuery } from 'src/sections/@dashboard/chat/ChatConversation/ChatSearch/useChatSearchQuery';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';

export const ChatSearch = () => {
  const theme = useTheme();

  const {
    conversation,
    setSearchTerm,
    goToMessage,
    setGoToMessage,
    editorConfig,
  } = useChatConversationContext();

  const { messages, isSearchLoading } = useChatSearchQuery();

  const { editor, editorLoaded } = useEditor(editorConfig);

  const handleGoToMessage = async (messageId: string) => {
    setGoToMessage(messageId);
  };

  if (!editorLoaded) {
    return null;
  }

  return (
    <Stack
      position="absolute"
      top={0}
      bottom={0}
      right={0}
      borderLeft="1px solid"
      borderTop="1px solid"
      borderColor="divider"
      width={370}
      maxWidth={1}
      height={1}
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      <Stack
        direction="row"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="divider"
        padding={theme.spacing(0.75, 2)}
        gap={1}
        sx={{
          backgroundColor: 'background.paper',
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          {isSearchLoading ? (
            <>
              <Iconify
                icon="eos-icons:loading"
                color={theme.palette.primary.main}
              />
              <Typography variant="subtitle1">Searching...</Typography>
            </>
          ) : (
            <>
              <Iconify
                icon="tabler:search"
                color={theme.palette.primary.main}
              />
              <Typography variant="subtitle1">
                {messages?.length || 'No'} results in {conversation.name}
              </Typography>
            </>
          )}
        </Stack>
        <IconButton
          size="small"
          onClick={() => {
            setSearchTerm('');
          }}
        >
          <Iconify icon="tabler:x" />
        </IconButton>
      </Stack>

      <Stack py={1.5} px={2} gap={1.25} sx={{ overflowY: 'auto' }}>
        {messages?.map((message) => (
          <Box
            key={message._id}
            sx={{
              backgroundColor:
                goToMessage === message._id
                  ? theme.palette.background.paper
                  : theme.palette.action.selected,
              borderRadius: 1,
              cursor: 'pointer',
              '& > .MuiBox-root': {
                px: 1,
                py: 1.5,
                borderRadius: 1,
                '& > .MuiBox-root': {
                  backgroundColor: 'transparent',
                },
              },
            }}
            onClick={() => handleGoToMessage(message._id)}
          >
            <ChatMessageItem
              message={message}
              conversation={conversation}
              disableActions
              editor={editor}
            />
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};
